/* Assistants & skills (group "You"): custom assistants, skills, plugins, prompt shortcuts, the store,
   creator monetization, personas and creator profiles. API: api/src/modules/assistants/README.md. */
import { lazy } from 'react';
import { Puzzle } from 'lucide-react';
import { defineFeature } from '../../app/feature';

export default defineFeature({
  id: 'assistants',
  title: 'Assistants & skills',
  short: 'Assistants',
  icon: Puzzle,
  group: 'You',
  route: '/assistants',
  order: 20,
  screen: lazy(() => import('./Screen.tsx')),
  commands: [
    { id: 'new-assistant', title: 'New assistant', to: '/assistants?new=1', keywords: ['gpt', 'custom', 'bot'] },
    { id: 'store', title: 'Browse the assistant store', to: '/assistants/store', keywords: ['marketplace', 'plugins', 'skills'] },
    { id: 'skills', title: 'Skills & prompt shortcuts', to: '/assistants/skills', keywords: ['SKILL.md', 'slash', 'prompts', 'shortcut'] },
    { id: 'new-skill', title: 'New skill (SKILL.md)', to: '/assistants/skills?new=1' },
    { id: 'plugins', title: 'Plugins', to: '/assistants/plugins', keywords: ['mcp', 'install'] },
    { id: 'personas', title: 'Personas', to: '/assistants/personas', keywords: ['character'] },
    { id: 'earnings', title: 'Creator earnings & payouts', to: '/assistants/earnings', keywords: ['money', 'stripe', 'payout'] },
    { id: 'profile', title: 'Creator profile & showcase', to: '/assistants/profile', keywords: ['public', 'handle'] },
  ],
  capabilities: ['ASSIST-01', 'ASSIST-02', 'ASSIST-03', 'ASSIST-04', 'ASSIST-05', 'ASSIST-06', 'ASSIST-07', 'COLLAB-06'],
});
